import styled from "styled-components";

export interface ISpriteIconCoords {
  sourceX: number;
  sourceY: number;
};

export interface ISpriteIconProps extends ISpriteIconCoords {
  width: string;
  height: string;
};

export const SpriteIconBox = styled.div<ISpriteIconProps>`
  width: ${props => props.width};
  height: ${props => props.height};
  background: url(${props => props.theme.images.spriteSheet.toString()});
  background-position: ${props => props.sourceX}px ${props => props.sourceY}px;
`;
